import { SModal } from './Modal.styles';
import { ModalProps } from './Modal.types';

export const Modal = ({ ...props }: ModalProps) => {
  return <SModal {...props} />;
};
